// src/components/BlogPostComponent.js
import React, { useState } from 'react';
import styled from '@emotion/styled';

const PostContainer = styled.article`
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 2rem;
  margin-bottom: 2rem;
`;

const PostTitle = styled.h2`
  color: ${props => props.theme.colors.secondary};
  font-size: 2rem;
`;

const PostMeta = styled.div`
  color: ${props => props.theme.colors.lightText};
  font-size: 0.9rem;
`;

const PostContent = styled.div`
  color: ${props => props.theme.colors.text};
  line-height: 1.6;

  p {
    margin-bottom: 1rem;
  }
`;

const ReadMoreButton = styled.button`
  background-color: ${props => props.theme.colors.primary};
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 5px;
  
  &:hover {
    background-color: ${props => props.theme.colors.secondary};
    cursor: pointer;
  }
`;

const BlogPostComponent = ({ title, meta, content }) => {
    const [isExpanded, setIsExpanded] = useState(false);

    const toggleExpansion = () => {
        setIsExpanded(!isExpanded);
    };

    return (
        <PostContainer>
            <PostTitle>{title}</PostTitle>
            <PostMeta>{meta}</PostMeta>
            <PostContent>
                {isExpanded ? (
                    <div dangerouslySetInnerHTML={{ __html: content }} />
                ) : (
                    <div dangerouslySetInnerHTML={{ __html: content.split('</p>')[0] + '</p>' }} />
                )}
            </PostContent>
            <ReadMoreButton onClick={toggleExpansion}>
                {isExpanded ? 'Show Less' : 'Read More'}
            </ReadMoreButton>
        </PostContainer>
    );
};

export default BlogPostComponent;
